import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'filterBy',
  standalone: true
})
export class FilterByPipe implements PipeTransform {
  transform(item: any[], arg: any, value: any): any[] {
    if (item && item.length) {
      return item.filter((i) => i[arg] === value );
    }
    return null;
  }
}
